import React from "react";

const SubTitle = ({ title }) => {
  return <h2 className="text-[#4A4A68] text-2xl font-bold my-4">{title}</h2>;
};

export default SubTitle;
